import { render, staticRenderFns } from "./SharedBrand.vue?vue&type=template&id=152b708a&"
import script from "./SharedBrand.vue?vue&type=script&lang=js&"
export * from "./SharedBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports